/**
 * The Living Valley progress bar: tall, with the amounts written inside.
 *
 * The "now" label lives INSIDE the fill, and the fill is never narrower than
 * that label (min-width: max-content). Before the audit the label sat on top
 * of the bar independently, so a small amount -- $8 of $60 -- put pale text
 * half on the green fill and half on the pale track, unreadable where it
 * crossed over. "of $60" sits on the track at the end; when the bar is full
 * it moves into the fill too, so it is always on green or always on paper,
 * never split across both.
 */

export function ProgressBar({
  label,
  value,
  target,
  full,
  now,
  of,
}: {
  label: string;
  value: number;
  target: number;
  full: boolean;
  now: string;
  of: string;
}) {
  const pct = target <= 0 ? 100 : Math.max(0, Math.min(100, Math.round((value / target) * 100)));
  const filled = value > 0;
  return (
    <div
      className={`bar goal-bar${full ? ' full' : ''}${filled ? ' has-fill' : ''}`}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={target}
      aria-valuenow={Math.min(Math.max(value, 0), target)}
      aria-valuetext={`${now} ${of}`}
      aria-label={label}
    >
      <div className={full ? 'bar-fill full' : 'bar-fill'} style={{ width: filled ? `${pct}%` : 0 }}>
        {filled ? <span className="bar-now">{now}</span> : null}
        {full ? <span className="bar-of">{of}</span> : null}
      </div>
      {filled ? null : <span className="bar-now on-track">{now}</span>}
      {full ? null : <span className="bar-of">{of}</span>}
    </div>
  );
}
